export const APIUrl = (): string => {
  return process.env.REACT_APP_API_URL || "";
};

export const APIKey = (): string => {
  return process.env.REACT_APP_API_KEY || "";
};

// ── AI Ready Ohio ─────────────────────────────────────────
export const AROApiUrl = (): string => {
  return process.env.REACT_APP_ARO_API_URL || "";
};

export const AROApiKey = (): string => {
  return process.env.REACT_APP_ARO_API_KEY || "";
};